import {
    TRANSACTIONS_FETCH,
    TRANSACTIONS_IS_FETCING,
    TRANSACTION_FILTER,
    SET_TRANSACTION_VIEW_FILTER,
    TRANSACTION_EDIT,
    UPDATE_TRANSACTION_STATUS
} from 'constants/transactions'

export default function transactionsReducer(state = {
    list: [],
    pageable: {
        sort: {
            'changeStatusTime': 'asc',
            'amount': 'asc',
            'comment': 'asc',
            'transactionId': false,
            'destination': 'asc',
            'ibId': false,
            'status': false,
            'creationTime': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case TRANSACTIONS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case TRANSACTION_EDIT:
            return {
                ...state,
            }
        case TRANSACTIONS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
						}
				case UPDATE_TRANSACTION_STATUS:
						state.list.find((item, i) => item.transactionId === action.payload.transactionId).status = action.payload.status
						return {
							...state,
							list: [...state.list]
						}
        case TRANSACTION_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        case SET_TRANSACTION_VIEW_FILTER:
          return {
              ...state,
              [action.payload.filterName]: action.payload.value 
          }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/transactions.js